import React, { useState } from 'react';
import { FiBell, FiChevronRight } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../context/NotificationContext';
import { getWhatsAppNotificationUrl } from '../utils/whatsappNotification';

export default function NotificationBell() {
  const BellIcon = FiBell as unknown as React.FC;
  const ChevronRightIcon = FiChevronRight as unknown as React.FC;
  const [open, setOpen] = useState(false);
  const { notifications, unreadCount, markRead } = useNotifications();
  const navigate = useNavigate();
  const openNotification = (notification: typeof notifications[number]) => {
    void markRead(notification.id);
    setOpen(false);
    const whatsappUrl = getWhatsAppNotificationUrl(notification);
    if (whatsappUrl) {
      window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
      return;
    }
    if (notification.type !== 'whatsapp_inbound') navigate(notification.deepLink);
  };
  return <div className="notification-bell">
    <button className={`notification-bell__button ${unreadCount > 0 ? 'notification-bell__button--active' : ''}`} onClick={() => setOpen((value) => !value)} aria-expanded={open} aria-label={`Notifications${unreadCount ? ` (${unreadCount} unread)` : ''}`}><BellIcon />{unreadCount > 0 && <span>{unreadCount > 99 ? '99+' : unreadCount}</span>}</button>
    {open && <div className="notification-bell__panel">
      <div className="notification-bell__header"><div><strong>Notifications</strong><small>{unreadCount ? `${unreadCount} unread` : 'All caught up'}</small></div></div>
      {notifications.length === 0 && <p className="notification-bell__empty">You’re all caught up.</p>}
      {notifications.slice(0, 12).map((notification) => <button key={notification.id} className={`notification-bell__item ${notification.readAt ? '' : 'notification-bell__item--unread'}`} onClick={() => openNotification(notification)}><span className="notification-bell__item-indicator" aria-hidden="true" /><span className="notification-bell__item-copy"><strong>{notification.title}</strong><span>{notification.body}</span></span><ChevronRightIcon /> </button>)}
    </div>}
  </div>;
}
